// max quantity function for variable products
document.addEventListener('DOMContentLoaded', function() {
    // Grab the WooCommerce variation form
    var $form = jQuery('form.variations_form');

    // When a variation is found/selected, WooCommerce passes the full variation object
    $form.on('found_variation', function(event, variation) {
        var qtyInput = document.querySelector('.product__quantity-input');
        if (!qtyInput) return;

        // If this variation allows backorders, remove any max attribute
        if (variation.backorders_allowed) {
            qtyInput.removeAttribute('max');
        } 
        // Otherwise enforce its stock-based cap
        else {
            qtyInput.setAttribute('max', variation.max_qty);
        }
    });

    // Optional: when the form resets (attributes cleared), remove the max so the user can start fresh
    $form.on('reset_data', function() {
        var qtyInput = document.querySelector('.product__quantity-input');
        if (qtyInput) {
            qtyInput.removeAttribute('max');
        }
    });
});
